<template>
    <div class="container container-float container-fixed container-header" :class="{'container-shadow': $root.isScrolled}">
      <div class="wrapper">
        <div class="container-float container-float-left">  
          <router-link tag="div" class="logo" :to="'/'"></router-link>
        </div>
        <div class="container-float container-float-right">
          <div>
            <a @click="$root.close()" class="close"></a>
          </div>
        </div>
        <div class="container container-small container-nopadding">
            <form @submit="submit">
                  <template v-if="$root.formdata.simple.filter == 'person'">
                    <input @keypress.enter.prevent="submit" class="inlineblock" v-model="$root.formdata.simple.q[0]" name="q0" type="text" :placeholder="$root.formdata.mode === 'simple' && $root.formdata.simple.q[0] ? $root.formdata.simple.q[0] : $root.t(`startpage:suchfeld_placeholder_name_${$root.formdata.simple.filter}`)">
                    <input @keypress.enter.prevent="submit" class="inlineblock"  v-model="$root.formdata.simple.q[1]" name="q1" type="text" :placeholder="$root.formdata.mode === 'simple' && $root.formdata.simple.q[1] ? $root.formdata.simple.q[1] : $root.t(`startpage:suchfeld_placeholder_vorname_${$root.formdata.simple.filter}`)">
                  </template>
                  <input 
                    v-model="$root.formdata.simple.q[0]" 
                    name="q" 
                    type="text" 
                    :placeholder="$root.formdata.mode === 'simple' && $root.formdata.simple.q[0] ? $root.formdata.simple.q[0] : $root.t(`startpage:suchfeld_placeholder_${$root.formdata.simple.filter}`)"
                    v-else
                  >
            </form>
        </div>
      </div>
    </div>
</template>


<script>


export default {
  name: 'Quicksearch',
  props: ['searching', 'callback', 'beforestart'],
  data() {
      return {
          s: this.searching
      }
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      this.s = true;
      this.$emit('update:searching', this.s)
      if ( typeof this.beforestart === 'function' ) this.beforestart();
      this.$root.formdata.offset = 0;
      this.$root.formdata.mode = 'simple';
      this.$root.result = await this.$store.dispatch('post', {
                          mode: '/search', 
                          params: this.$root.formdata,
                          headers: {
                            'Content-type': 'application/json',
                          }
                      });
      this.s = false;
      this.$emit('update:searching', this.s)
      this.searching = true;
      if ( typeof this.callback === 'function' ) this.callback();
      return false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@import '../main';

.container-header {
    .wrapper {
        white-space: nowrap;
        @include lg() {
            max-width: calc(1024px - 2em);
            margin: auto;
        }
    }
    .container-small {
        @include lg() {
            width: calc(100% - 7em);
        }
    }
}
</style>
